/*eslint no-console:1 */
import axios from 'axios';
import { trigger } from '../lib/event';
const addedClassName = 'is-added';
const beforeLeaveClass = 'is-hovered';
const disabledClassName = 'is-disabled';

export default class AddTo {

  /**
   *
   * @param  {Node} element the node given by the component-handler
   */
  constructor(element) {
    // console.log(element);
    this.el = element;
    this.el.handler = this;
    this.isAdded = this.getAddedState();
    this.route = this.el.getAttribute('data-route');
    this.type = ((instance) => {
      switch (instance.route) {
      default:
        return 'movie';

      case 'likeScene':
        return 'scene';

      case 'likeStar':
        return 'performer';

      case 'likeCategory':
        return 'category';

      case 'likeSeries':
        return 'series';

      case 'likeStudio':
        return 'studio';
      }
    })(this);
    this.url = `${window.location.protocol}//api.${window.location.hostname.split('.').slice(window.location.hostname.indexOf('staging') > -1 ? -3 : -2).join('.')}/like`;
    this.axiosType = 'POST';
    this.modalTrigger = document.getElementById('modal-trigger');
    this.modal = document.getElementById('modal-overlay');
    this.modalText = this.el.getAttribute('data-modal-text');
    this.entityId = this.el.getAttribute('data-entity-id');
    try {

      this.data = JSON.parse(this.entityId);
    } catch (e) {

      this.handleError(e, 'unable to parse JSON from data-entity-id');
    }

    this.registerEvents();
  }

  handleError(error, additional = '') {

    this.el.style.display = 'none';
    // console.log(error, additional);
  }

  registerEvents() {

    this.el.addEventListener('click', this.onClick.bind(this), false);
    this.el.addEventListener('mouseleave', this.removeBeforeLeaveClass.bind(this), false);
  }

  getAddedState() {
    return this.el.classList.contains(addedClassName);
  }

  /**
   * Set visual state of the widget
   *
   * @param {boolean} isAdded
   * @returns {undefined}
   */
  setAddedState(isAdded) {

    this.isAdded = isAdded;
    if (isAdded) {

      this.el.classList.add(addedClassName);
      this.el.classList.add(beforeLeaveClass);
    } else {
      this.el.classList.remove(addedClassName);
      this.el.classList.remove(beforeLeaveClass);
      if (document.querySelector('.page-account-favorites')) {
        if (this.el.classList.contains('fav-category') || this.el.classList.contains('fav-series')) {
          this.el.parentNode.parentNode.style.display = 'none';
        } else {
          this.el.parentNode.parentNode.parentNode.style.display = 'none';
        }
      }
    }
  }

  /**
   * Check if the widget is in disabled/read-only state
   *
   * @returns {boolean}
   */
  getDisabled() {

    return this.el.classList.contains(disabledClassName);
  }

  onClick(e) {

    e.preventDefault();
    if (this.getDisabled()) {

      if (this.modalText) {

        this.modal.querySelector('.is-info span').innerHTML = this.modalText;
      }
      trigger(this.modalTrigger, 'click');
    } else {

      this.changeAddedState();
    }
  }

  removeBeforeLeaveClass() {

    this.el.classList.remove(beforeLeaveClass);
  }

  changeAddedState() {

    this.data.like = !this.isAdded;

    if (window.routes) {

      axios({
        method: this.axiosType,
        url: this.url,
        withCredentials: true,
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        },
        data: {
          type: this.type,
          identifier: `${this.data.itemNumber || this.data.id || this.data.star_id }`,
          liked: !this.isAdded
        }
      })
      .then(res => {

        if (this.isAdded) {

          // handle remove
          // on success:
          this.setAddedState(false);
        } else {

          // handle add
          // on success:
          this.setAddedState(true);
        }

        this.syncState();
      })
      .catch(error => {
        throw `AddTo.js, axios fetch failed: ${error.message} in ${error.fileName}:${error.LineNumber}`;
      });
    } else {

      if (this.isAdded) {

        // handle remove
        // on success:
        this.setAddedState(false);
      } else {

        // handle add
        // on success:
        this.setAddedState(true);
      }
      this.syncState();
    }
  }

  /**
   * Synchronize widget state with other widgets referencing the same item
   *
   * @returns {undefined}
   */
  syncState() {

    const selector = '[data-entity-id="' + this.entityId.replace(/"/g, '\\"') + '"]';
    document.querySelectorAll(selector).forEach(el => {

      if (el != this.el && el.handler) {

        el.handler.setAddedState(this.isAdded);
      }
    });
  }

  onLoadDynamic(isAdded) {

    this.setAddedState(isAdded);
    this.syncState();
  }
}
